<script setup lang="ts">
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import { PageProps } from "@/Types/index.d";
import {BlockResource, BlockTypeEnum, TenantThemeEnum} from "@/Types/generated.d";
import NewsletterForm from "@/Pages/Frontend/Newsletter/Partials/Form.vue";
import { useSanitize } from '@/Composables/Shared/useSanitize';

// --- Props
// --- Data
const sanitize = useSanitize();
// --- Computed
const initialPageProps = computed(() => usePage<PageProps>().props);
const block = computed<BlockResource | undefined>(() =>
    initialPageProps.value.blocks?.find((block) => {
        return block.type === BlockTypeEnum.NEWSLETTER;
    }),
);
// --- Methods
// --- Watch
// --- Provide
</script>
<template>
    <div class="newsletter-block" v-if="initialPageProps.theme === TenantThemeEnum.IXOCOLLECTIONS">
        <div class="container">
            <p class="newsletter-block__title">{{ block?.title }}</p>
            <div class="newsletter-block__text prose max-w-none" v-html="sanitize.html(block?.content)"></div>

            <NewsletterForm />
        </div>
    </div>
</template>
<style lang="postcss" scoped>
.newsletter-block {
    @apply bg-[#FCFCFC] py-28;
}
.newsletter-block__title {
    @apply mb-7 text-center leading-tight text-fxl lg:text-f2xl font-[600] text-[#353535];
}
.newsletter-block__text {
    @apply mb-7 text-center text-fsm font-light text-[#353535];
}
</style>
